const toText = (value) => {
  if (value === undefined || value === null) return "";
  if (Array.isArray(value)) return value.map(toText).filter(Boolean).join(", ");
  if (typeof value === "object") return toText(value.Name || value.name || value.TagName || value.Value || value.tags || value.Names || value.names || "");
  const text = String(value).trim();
  
if (text.startsWith("[") && text.endsWith("]")) {
    try {
        const parsed = JSON.parse(text);
        if (Array.isArray(parsed)) return toText(parsed);
    } catch (_) {
    }
}

return text;
};
const firstValue = (data, keys) => {
  if (!data) return "";
  for (const key of keys) {
    const value = toText(data[key]);
    if (value) return value;
  }
  return "";
};

export const getReportMachineInfo = (machine) => ({
  tags: firstValue(machine, ["MachineTags", "MachineTagNames", "TagNames", "Tags", "tags", "tagNames"]),
  region: firstValue(machine, ["RegionName", "Region", "MachineRegionName", "Rejon", "region", "rejon"]),
  route: firstValue(machine, ["RouteName", "Route", "MachineRouteName", "Trasa", "route", "trasa"])
});

const norm = (str) => String(str || "").trim().toLocaleLowerCase("pl-PL");

export const matchesReportFilters = (machine, { tag, region, route }) => {
  const info = getReportMachineInfo(machine);
  return (!norm(tag) || norm(info.tags).includes(norm(tag))) &&
    (!norm(region) || norm(info.region).includes(norm(region))) &&
    (!norm(route) || norm(info.route).includes(norm(route)));
};

export const hasReportFilters = ({ tag, region, route }) =>
  Boolean(norm(tag) || norm(region) || norm(route));

export const reportFilterOptions = (machines, key) => {
  const values = new Set();
  (machines || []).forEach((machine) => {
    const field = getReportMachineInfo(machine)[key];
    if (!field) return;
    if (key === "tags") {
      field.split(/[,;]+/).map((item) => item.trim()).filter(Boolean).forEach((v) => values.add(v));
    } else {
      values.add(field);
    }
  });
  return Array.from(values).sort((a, b) => a.localeCompare(b, "pl"));
};